import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator';
import FJAIAudioLeftT2M from '../view/FJAIAudioLeftT2M';

const FJAIAudioLeftT2MContainer = () => {
    const dispatch = useDispatch();

    const subTabIndex = useSelector(state => state.AIAudioGenerator.subTabIndex);
    const musicDuration = useSelector(state => state.AIAudioGenerator.musicDuration);
    const instrumentalDuration = useSelector(state => state.AIAudioGenerator.instrumentalDuration);
    const t2mLyricContent = useSelector(state => state.AIAudioGenerator.t2mLyricContent);
    const musicPrompt = useSelector(state => state.AIAudioGenerator.musicPrompt);
    const instrumentalPrompt = useSelector(state => state.AIAudioGenerator.instrumentalPrompt);
    const lyricDesc = useSelector(state => state.AIAudioGenerator.lyricDesc);
    const isGenerateLyricsLoading = useSelector(state => state.AIAudioGenerator.isGenerateLyricsLoading);
    const musicStyles = useSelector(state => state.AIAudioGenerator.musicStyles);
    const instrumentStyles = useSelector(state => state.AIAudioGenerator.instrumentStyles);
    const isEnableLyrics = useSelector(state => state.AIAudioGenerator.isEnableLyricsT2M);

    const onChangeSubTab = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeSubTabIndexAction(value));
        },
        [dispatch],
    );

    const onChangeMusicDuration = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeMusicDurationAction(value));
        },
        [dispatch],
    );

    const onChangeInstrumentalDuration = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeInstrumentalDurationAction(value));
        },
        [dispatch],
    );

    const onLyricContentChange = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeT2MLyricContentAction(value));
        },
        [dispatch],
    );

    const onLyricDescChange = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.onLyricDescChangeAction(value));
        },
        [dispatch],
    );

    const getInspire = useCallback(() => {
        dispatch(FJActionAIAudioGenerator.getInspireAction());
    }, [dispatch]);

    const generateLyrics = useCallback(() => {
        dispatch(FJActionAIAudioGenerator.generateLyricAction());
    }, [dispatch]);

    const onChangeMusicStyles = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeMusicStylesAction(value));
        },
        [dispatch],
    );

    const onChangeInstrumentStyles = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeInstrumentStylesAction(value));
        },
        [dispatch],
    );

    const onChangeMusicPrompt = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeMusicPromptAction(value));
        },
        [dispatch],
    );

    const onChangeInstrumentalPrompt = useCallback(
        value => {
            dispatch(FJActionAIAudioGenerator.changeInstrumentalPromptAction(value));
        },
        [dispatch],
    );

    const onToggleLyrics = useCallback(
        enabled => {
            dispatch(FJActionAIAudioGenerator.toggleT2MLyricsEnabledAction(enabled));
        },
        [dispatch],
    );

    return (
        <FJAIAudioLeftT2M
            subTabIndex={subTabIndex}
            onChangeSubTab={onChangeSubTab}
            musicPrompt={musicPrompt}
            instrumentalPrompt={instrumentalPrompt}
            onChangeMusicPrompt={onChangeMusicPrompt}
            onChangeInstrumentalPrompt={onChangeInstrumentalPrompt}
            getInspire={getInspire}
            musicDuration={musicDuration}
            onChangeMusicDuration={onChangeMusicDuration}
            instrumentalDuration={instrumentalDuration}
            onChangeInstrumentalDuration={onChangeInstrumentalDuration}
            lyricContent={t2mLyricContent}
            onLyricContentChange={onLyricContentChange}
            lyricDesc={lyricDesc}
            onLyricDescChange={onLyricDescChange}
            generateLyrics={generateLyrics}
            isGenerateLyricsLoading={isGenerateLyricsLoading}
            musicStyles={musicStyles}
            instrumentStyles={instrumentStyles}
            onChangeMusicStyles={onChangeMusicStyles}
            onChangeInstrumentStyles={onChangeInstrumentStyles}
            isEnableLyrics={isEnableLyrics}
            onToggleLyrics={onToggleLyrics}
        />
    );
};

export default FJAIAudioLeftT2MContainer;
